import React, { Component } from 'react';
import { string } from 'prop-types';

import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';

class TermsAndConditions extends Component {
  static propTypes = {
    id: string.isRequired
  };

  render() {
    const { id } = this.props;
    const isMobile = window.innerWidth < 992;
    const screenHeight = window.innerHeight;

    let styles = {};

    isMobile
      ? (styles.minHeight = `${screenHeight}px`)
      : (styles.height = `${screenHeight}px`);

    const textboxContent = {
      content: '',
      header: 'Terms & Conditions',
      id: 0
    };

    return (
      <div
        id={id}
        className={
          isMobile
            ? `panel d-flex align-items-center flex-column`
            : `panel d-flex align-items-center`
        }
        style={styles}
      >
        {isMobile ? (
          <Mobile textboxContent={textboxContent} screenHeight={screenHeight} />
        ) : (
          <Desktop
            textboxContent={textboxContent}
            screenHeight={screenHeight}
            heightSm={this.props.heightSm}
          />
        )}
      </div>
    );
  }
}

export default TermsAndConditions;



// WEBPACK FOOTER //
// ./src/components/Legal/TermsAndConditions/TermsAndConditions.jsx